var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQueries } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '#query-hooks';
import { guestLinkFsEntryGetPathQueryOptions } from './useGuestLinkFsEntryGetPath';
export const useGuestLinksFsEntryGetPathBulk = ({ filespaceId, links, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const combine = useCallback((results) => Object.fromEntries(results.map((result, index) => [
        links[index]?.fsEntryId ?? '',
        result,
    ])), [links]);
    const queriesByEntryId = useQueries({
        queries: links.map((link) => guestLinkFsEntryGetPathQueryOptions({
            workspaceId,
            filespaceId,
            linkId: link.id,
            fsEntryId: link.fsEntryId,
            plugFilespaceClient,
            emailVerified: currentUser?.emailVerified,
        })),
        combine,
    });
    return queriesByEntryId;
};
_react_refresh_temp_1(useGuestLinksFsEntryGetPathBulk, "geXgWMwvNJaEsk5HmdgzYTwVb/I=", false, () => [useAuthProvider, usePlugFilespaceClient, useQueries]);
